import "core-js/modules/es.promise.finally.js";
import axios from 'axios';
import { createAction, getType } from 'typesafe-actions';
import { combineReducers } from 'redux';
import { put, takeLatest, call, select, all } from 'redux-saga/effects';
import { decode } from 'base-64';
import React, { useState, useCallback } from 'react';
import { createDispatchHook, createSelectorHook, Provider } from 'react-redux';

var Client = /*#__PURE__*/function () {
  function Client() {}

  Client.init = function init(options) {
    this.axiosInstance = axios.create({
      baseURL: options.apiEndpoint,
      responseType: 'json',
      headers: {
        'Content-Type': 'application/json'
      }
    });
    this.sessionStorage = options.sessionStorage;
    this.persistentStorage = options.persistentStorage;
  };

  Client.getAxiosInstance = function getAxiosInstance() {
    if (!this.axiosInstance) {
      throw Error('Provider must be used');
    }

    return this.axiosInstance;
  };

  Client.getSessionStorage = function getSessionStorage() {
    if (!this.sessionStorage) {
      throw Error('Provider must be used');
    }

    return this.sessionStorage;
  };

  Client.getPersistentStorage = function getPersistentStorage() {
    if (!this.persistentStorage) {
      throw Error('Provider must be used');
    }

    return this.persistentStorage;
  };

  return Client;
}();

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}

var AuthActionTypes;

(function (AuthActionTypes) {
  AuthActionTypes["ADMIN_SIGN_IN"] = "auth/ADMIN_SIGN_IN";
  AuthActionTypes["ADMIN_SIGN_OUT"] = "auth/ADMIN_SIGN_OUT";
  AuthActionTypes["RESTAURANT_OWNER_SIGN_IN"] = "auth/RESTAURANT_OWNER_SIGN_IN";
  AuthActionTypes["RESTAURANT_OWNER_SIGN_OUT"] = "auth/RESTAURANT_OWNER_SIGN_OUT";
})(AuthActionTypes || (AuthActionTypes = {}));

var prefix = 'remplisVert';
var actionPrefix = '@' + prefix + '/';
var adminSignIn = /*#__PURE__*/createAction(actionPrefix + AuthActionTypes.ADMIN_SIGN_IN)();
var adminSignOut = /*#__PURE__*/createAction(actionPrefix + AuthActionTypes.ADMIN_SIGN_OUT)();
var userSignIn = /*#__PURE__*/createAction(actionPrefix + AuthActionTypes.RESTAURANT_OWNER_SIGN_IN)();
var userSignOut = /*#__PURE__*/createAction(actionPrefix + AuthActionTypes.RESTAURANT_OWNER_SIGN_OUT)();
var authActions = {
  __proto__: null,
  adminSignIn: adminSignIn,
  adminSignOut: adminSignOut,
  userSignIn: userSignIn,
  userSignOut: userSignOut
};
var SessionActionTypes;

(function (SessionActionTypes) {
  SessionActionTypes["START"] = "session/START";
})(SessionActionTypes || (SessionActionTypes = {}));

var actionPrefix$1 = '@' + prefix + '/';
var start = /*#__PURE__*/createAction(actionPrefix$1 + SessionActionTypes.START)();
var sessionActions = {
  __proto__: null,
  start: start
};
var AuthActionTypes$1;

(function (AuthActionTypes) {
  AuthActionTypes["ADD_ADMIN"] = "admins/ADD_ADMIN";
  AuthActionTypes["SET_ADMIN"] = "admins/SET_ADMIN";
  AuthActionTypes["SET_ADMINS"] = "admins/SET_ADMINS";
  AuthActionTypes["UPDATE_ADMIN"] = "admins/UPDATE_ADMIN";
  AuthActionTypes["DELETE_ADMIN"] = "admins/DELETE_ADMIN";
})(AuthActionTypes$1 || (AuthActionTypes$1 = {}));

var actionPrefix$2 = '@' + prefix + '/';
var addAdmin = /*#__PURE__*/createAction(actionPrefix$2 + AuthActionTypes$1.ADD_ADMIN)();
var setAdmin = /*#__PURE__*/createAction(actionPrefix$2 + AuthActionTypes$1.SET_ADMIN)();
var setAdmins = /*#__PURE__*/createAction(actionPrefix$2 + AuthActionTypes$1.SET_ADMINS)();
var updateAdmin = /*#__PURE__*/createAction(actionPrefix$2 + AuthActionTypes$1.UPDATE_ADMIN)();
var deleteAdmin = /*#__PURE__*/createAction(actionPrefix$2 + AuthActionTypes$1.DELETE_ADMIN)();
var adminsActions = {
  __proto__: null,
  addAdmin: addAdmin,
  setAdmin: setAdmin,
  setAdmins: setAdmins,
  updateAdmin: updateAdmin,
  deleteAdmin: deleteAdmin
};
var AuthActionTypes$2;

(function (AuthActionTypes) {
  AuthActionTypes["ADD_ESTABLISHMENT"] = "establishments/ADD_ESTABLISHMENT";
  AuthActionTypes["SET_ESTABLISHMENTS"] = "establishments/SET_ESTABLISHMENTS";
  AuthActionTypes["SET_ESTABLISHMENT"] = "establishments/SET_ESTABLISHMENT";
  AuthActionTypes["SET_ESTABLISHMENT_GROUPS"] = "establishments/SET_ESTABLISHMENT_GROUPS";
  AuthActionTypes["UPDATE_ESTABLISHMENT"] = "establishments/UPDATE_ESTABLISHMENT";
  AuthActionTypes["DELETE_ESTABLISHMENT"] = "establishments/DELETE_ESTABLISHMENT";
  AuthActionTypes["SHARE_PHOTO_ESTABLISHMENT"] = "establishments/SHARE_PHOTO_ESTABLISHMENT";
  AuthActionTypes["FETCH_ESTABLISHMENTS"] = "establishments/FETCH_ESTABLISHMENTS";
})(AuthActionTypes$2 || (AuthActionTypes$2 = {}));

var actionPrefix$3 = '@' + prefix + '/';
var addEstablishment = /*#__PURE__*/createAction(actionPrefix$3 + AuthActionTypes$2.ADD_ESTABLISHMENT)();
var setEstablishments = /*#__PURE__*/createAction(actionPrefix$3 + AuthActionTypes$2.SET_ESTABLISHMENTS)();
var setEstablishment = /*#__PURE__*/createAction(actionPrefix$3 + AuthActionTypes$2.SET_ESTABLISHMENT)();
var updateEstablishment = /*#__PURE__*/createAction(actionPrefix$3 + AuthActionTypes$2.UPDATE_ESTABLISHMENT)();
var deleteEstablishment = /*#__PURE__*/createAction(actionPrefix$3 + AuthActionTypes$2.DELETE_ESTABLISHMENT)();
var sharePhotoEstablishment = /*#__PURE__*/createAction(actionPrefix$3 + AuthActionTypes$2.SHARE_PHOTO_ESTABLISHMENT)();
var fetchEstablishments = /*#__PURE__*/createAction(actionPrefix$3 + AuthActionTypes$2.FETCH_ESTABLISHMENTS)();
var establishmentsActions = {
  __proto__: null,
  addEstablishment: addEstablishment,
  setEstablishments: setEstablishments,
  setEstablishment: setEstablishment,
  updateEstablishment: updateEstablishment,
  deleteEstablishment: deleteEstablishment,
  sharePhotoEstablishment: sharePhotoEstablishment,
  fetchEstablishments: fetchEstablishments
};
var UsersActionTypes;

(function (UsersActionTypes) {
  UsersActionTypes["ADD_RESTAURANT_OWNER"] = "admins/ADD_RESTAURANT_OWNER";
  UsersActionTypes["SET_RESTAURANT_OWNER"] = "admins/SET_RESTAURANT_OWNER";
  UsersActionTypes["SET_RESTAURANT_OWNERS"] = "admins/SET_RESTAURANT_OWNERS";
  UsersActionTypes["UPDATE_RESTAURANT_OWNER"] = "admins/UPDATE_RESTAURANT_OWNER";
  UsersActionTypes["DELETE_RESTAURANT_OWNER"] = "admins/DELETE_RESTAURANT_OWNER";
})(UsersActionTypes || (UsersActionTypes = {}));

var actionPrefix$4 = '@' + prefix + '/';
var setUser = /*#__PURE__*/createAction(actionPrefix$4 + UsersActionTypes.SET_RESTAURANT_OWNER)();
var setUsers = /*#__PURE__*/createAction(actionPrefix$4 + UsersActionTypes.SET_RESTAURANT_OWNERS)();
var updateUser = /*#__PURE__*/createAction(actionPrefix$4 + UsersActionTypes.UPDATE_RESTAURANT_OWNER)();
var deleteUser = /*#__PURE__*/createAction(actionPrefix$4 + UsersActionTypes.DELETE_RESTAURANT_OWNER)();
var usersActions = {
  __proto__: null,
  setUser: setUser,
  setUsers: setUsers,
  updateUser: updateUser,
  deleteUser: deleteUser
};
var CommonActionTypes;

(function (CommonActionTypes) {
  CommonActionTypes["SET_ERROR"] = "common/SET_ERROR";
})(CommonActionTypes || (CommonActionTypes = {}));

var actionPrefix$5 = '@ubidreams-react-sugg1144/@' + prefix + '/';
var setError = /*#__PURE__*/createAction(actionPrefix$5 + CommonActionTypes.SET_ERROR)();
var commonActions = {
  __proto__: null,
  setError: setError
};

var actions = /*#__PURE__*/_extends({}, authActions, sessionActions, adminsActions, establishmentsActions, usersActions, commonActions);

var initialState = {};

var reducer = function reducer(state, action) {
  if (state === void 0) {
    state = initialState;
  }

  switch (action.type) {
    case getType(actions.adminSignIn):
      {
        var response = action.payload;
        var admin = response.admin,
            _response$authenticat = response.authentication,
            token = _response$authenticat.token,
            longLifeToken = _response$authenticat.longLifeToken;
        return _extends({}, state, {
          admin: admin,
          token: token,
          longLifeToken: longLifeToken,
          user: undefined
        });
      }

    case getType(actions.adminSignOut):
      {
        return _extends({}, state, {
          admin: undefined,
          token: undefined,
          longLifeToken: undefined
        });
      }

    case getType(actions.userSignIn):
      {
        var _response = action.payload;
        var user = _response.user,
            _response$authenticat2 = _response.authentication,
            _token = _response$authenticat2.token,
            _longLifeToken = _response$authenticat2.longLifeToken;

        if (_longLifeToken !== undefined) {
          return _extends({}, state, {
            user: user,
            token: _token,
            longLifeToken: _longLifeToken,
            admin: undefined
          });
        } else {
          return _extends({}, state, {
            user: user,
            token: _token,
            admin: undefined
          });
        }
      }

    case getType(actions.userSignOut):
      {
        return _extends({}, state, {
          user: undefined,
          token: undefined,
          longLifeToken: undefined
        });
      }

    case getType(actions.start):
      {
        var started = action.payload;

        if (!started) {
          return initialState;
        }

        return state;
      }

    default:
      return state;
  }
};

var initialState$1 = {
  started: false
};

var reducer$1 = function reducer(state, action) {
  if (state === void 0) {
    state = initialState$1;
  }

  switch (action.type) {
    case getType(actions.start):
      {
        var started = action.payload;

        if (!started) {
          return initialState$1;
        }

        return _extends({}, state, {
          started: started
        });
      }

    default:
      return state;
  }
};

var PermissionActions;

(function (PermissionActions) {
  PermissionActions["Manage"] = "manage";
  PermissionActions["Read"] = "read";
  PermissionActions["Create"] = "create";
  PermissionActions["Update"] = "update";
  PermissionActions["Delete"] = "delete";
  PermissionActions["Export"] = "export";
  PermissionActions["Share"] = "share";
})(PermissionActions || (PermissionActions = {}));

var PermissionSubjects;

(function (PermissionSubjects) {
  PermissionSubjects["Establishment"] = "establishment";
  PermissionSubjects["Admin"] = "admin";
  PermissionSubjects["User"] = "user";
})(PermissionSubjects || (PermissionSubjects = {}));

var initialState$2 = {};

var convertPermissions = function convertPermissions(permissions) {
  return permissions.map(function (permission) {
    var action = permission.action;

    switch (permission.action) {
      case PermissionActions.Read:
        action = PermissionActions.Read;
        break;

      case PermissionActions.Create:
        action = PermissionActions.Create;
        break;

      case PermissionActions.Update:
        action = PermissionActions.Update;
        break;

      case PermissionActions.Delete:
        action = PermissionActions.Delete;
        break;

      case PermissionActions.Manage:
        action = PermissionActions.Manage;
        break;

      case PermissionActions.Export:
        action = PermissionActions.Export;
        break;
    }

    var subject = permission.subject;

    switch (permission.subject) {
      case PermissionSubjects.Admin:
        subject = PermissionSubjects.Admin;
        break;

      case PermissionSubjects.Establishment:
        subject = PermissionSubjects.Establishment;
        break;

      case PermissionSubjects.User:
        subject = PermissionSubjects.User;
        break;
    }

    return _extends({}, permission, {
      action: action,
      subject: subject
    });
  });
};

var reducer$2 = function reducer(state, action) {
  if (state === void 0) {
    state = initialState$2;
  }

  switch (action.type) {
    case getType(actions.addAdmin):
      {
        var admin = action.payload;
        var _state = state,
            admins = _state.admins;

        if (admins !== undefined) {
          admin.permissions = convertPermissions(admin.permissions);
          admins.push(admin);
        }

        return _extends({}, state, {
          admins: admins
        });
      }

    case getType(actions.setAdmin):
      {
        var _admin = action.payload;
        var _state2 = state,
            _admins = _state2.admins;
        var found = false;

        if (_admins !== undefined) {
          _admins = _admins.map(function (searchAdmin) {
            if (searchAdmin.id === _admin.id) {
              found = true;
              _admin.permissions = convertPermissions(_admin.permissions);
              return _admin;
            }

            return searchAdmin;
          });
        }

        if (!found) {
          if (_admins !== undefined) {
            _admins.push(_admin);
          } else {
            _admins = [_admin];
          }
        }

        return _extends({}, state, {
          admins: _admins
        });
      }

    case getType(actions.setAdmins):
      {
        var _admins2 = action.payload;
        _admins2 = _admins2.map(function (admin) {
          admin.permissions = convertPermissions(admin.permissions);
          return admin;
        });
        return _extends({}, state, {
          admins: _admins2
        });
      }

    case getType(actions.updateAdmin):
      {
        var _admin2 = action.payload;
        var _state3 = state,
            _admins3 = _state3.admins;

        if (_admins3 !== undefined) {
          _admins3 = _admins3.map(function (searchAdmin) {
            if (searchAdmin.id === _admin2.id) {
              _admin2.permissions = convertPermissions(_admin2.permissions);
              return _admin2;
            }

            return searchAdmin;
          });
        }

        return _extends({}, state, {
          admins: _admins3
        });
      }

    case getType(actions.deleteAdmin):
      {
        var id = action.payload;
        var _state4 = state,
            _admins4 = _state4.admins;

        if (_admins4 !== undefined) {
          var adminIndex = _admins4.findIndex(function (admin) {
            return admin.id === id;
          });

          if (adminIndex !== -1) {
            _admins4.splice(adminIndex, 1);
          }
        }

        return _extends({}, state, {
          admins: _admins4
        });
      }

    case getType(actions.start):
      {
        var started = action.payload;

        if (!started) {
          return initialState$2;
        }

        return state;
      }

    default:
      return state;
  }
};

var initialState$3 = {};

var reducer$3 = function reducer(state, action) {
  if (state === void 0) {
    state = initialState$3;
  }

  switch (action.type) {
    case getType(actions.addEstablishment):
      {
        var admin = action.payload;
        var _state = state,
            establishments = _state.establishments;

        if (establishments !== undefined) {
          establishments.push(admin);
        }

        return _extends({}, state, {
          establishments: establishments
        });
      }

    case getType(actions.setEstablishments):
      {
        var _establishments = action.payload;
        return _extends({}, state, {
          establishments: _establishments
        });
      }

    case getType(actions.updateEstablishment):
      {
        var establishment = action.payload;
        var _state2 = state,
            _establishments2 = _state2.establishments;

        if (_establishments2 !== undefined) {
          _establishments2 = _establishments2.map(function (searchEstablishment) {
            if (searchEstablishment.id === establishment.id) {
              return establishment;
            }

            return searchEstablishment;
          });
        }

        return _extends({}, state, {
          establishments: _establishments2
        });
      }

    case getType(actions.setEstablishment):
      {
        var _establishment = action.payload;
        var _state3 = state,
            _establishments3 = _state3.establishments;
        var found = false;

        if (_establishments3 !== undefined) {
          _establishments3 = _establishments3.map(function (searchEstablishment) {
            if (searchEstablishment.id === _establishment.id) {
              found = true;
              return _establishment;
            }

            return searchEstablishment;
          });
        }

        if (!found) {
          if (_establishments3 !== undefined) {
            _establishments3.push(_establishment);
          } else {
            _establishments3 = [_establishment];
          }
        }

        return _extends({}, state, {
          establishments: _establishments3
        });
      }

    case getType(actions.deleteEstablishment):
      {
        var id = action.payload;
        var _state4 = state,
            _establishments4 = _state4.establishments;

        if (_establishments4 !== undefined) {
          var establishmentIndex = _establishments4.findIndex(function (establishment) {
            return establishment.id === id;
          });

          if (establishmentIndex !== -1) {
            _establishments4.splice(establishmentIndex, 1);
          }
        }

        return _extends({}, state, {
          establishments: _establishments4
        });
      }

    case getType(actions.sharePhotoEstablishment):
      {
        var _id = action.payload;
        var _state5 = state,
            _establishments5 = _state5.establishments;

        if (_establishments5 !== undefined) {
          var _establishmentIndex = _establishments5.findIndex(function (establishment) {
            return establishment.id === _id;
          });

          if (_establishmentIndex !== -1) {
            var photo = _establishments5[_establishmentIndex].photo;

            if (photo) {
              _establishments5[_establishmentIndex].photo = _extends({}, photo, {
                isFacebookShared: true
              });
            }
          }
        }

        return _extends({}, state, {
          establishments: _establishments5
        });
      }

    case getType(actions.updateUser):
      {
        var user = action.payload;
        var _state6 = state,
            _establishments6 = _state6.establishments;

        if (_establishments6 !== undefined) {
          // remove association establishment -> user
          var _establishmentIndex2 = _establishments6.findIndex(function (establishment) {
            return establishment.user === user.id;
          });

          if (_establishmentIndex2 !== -1) {
            _establishments6[_establishmentIndex2].user = undefined;
          } // add association establishment -> user


          if (user.establishment) {
            var _establishmentIndex3 = _establishments6.findIndex(function (establishment) {
              return establishment.id === user.establishment;
            });

            if (_establishmentIndex3 !== -1) {
              _establishments6[_establishmentIndex3].user = user.id;
            }
          }
        }

        return _extends({}, state, {
          establishments: _establishments6
        });
      }

    case getType(actions.start):
      {
        var started = action.payload;

        if (!started) {
          return initialState$3;
        }

        return state;
      }

    case getType(actions.adminSignOut):
      {
        return _extends({}, state, {
          establishments: undefined
        });
      }

    default:
      return state;
  }
};

var initialState$4 = {};

var reducer$4 = function reducer(state, action) {
  if (state === void 0) {
    state = initialState$4;
  }

  switch (action.type) {
    case getType(actions.setUser):
      {
        var user = action.payload;
        var _state = state,
            users = _state.users;
        var found = false;

        if (users !== undefined) {
          users = users.map(function (searchUser) {
            if (searchUser.id === user.id) {
              found = true;
              return user;
            }

            return searchUser;
          });
        }

        if (!found) {
          if (users !== undefined) {
            users.push(user);
          } else {
            users = [user];
          }
        }

        return _extends({}, state, {
          users: users
        });
      }

    case getType(actions.setUsers):
      {
        var _users = action.payload;
        return _extends({}, state, {
          users: _users
        });
      }

    case getType(actions.updateUser):
      {
        var _user = action.payload;
        var _state2 = state,
            _users2 = _state2.users;

        if (_users2 !== undefined) {
          _users2 = _users2.map(function (searchUser) {
            if (searchUser.id === _user.id) {
              return _user;
            }

            return searchUser;
          });
        }

        return _extends({}, state, {
          users: _users2
        });
      }

    case getType(actions.deleteUser):
      {
        var id = action.payload;
        var _state3 = state,
            _users3 = _state3.users;

        if (_users3 !== undefined) {
          var userIndex = _users3.findIndex(function (user) {
            return user.id === id;
          });

          if (userIndex !== -1) {
            _users3.splice(userIndex, 1);
          }
        }

        return _extends({}, state, {
          users: _users3
        });
      }

    case getType(actions.start):
      {
        var started = action.payload;

        if (!started) {
          return initialState$4;
        }

        return state;
      }

    case getType(actions.adminSignOut):
      {
        return _extends({}, state, {
          users: undefined
        });
      }

    default:
      return state;
  }
};

var remplisVertReducers = {
  auth: reducer,
  session: reducer$1,
  admins: reducer$2,
  establishments: reducer$3,
  users: reducer$4
};
var remplisVertReducer = /*#__PURE__*/combineReducers(remplisVertReducers);

function createCommonjsModule(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}

var runtime_1 = createCommonjsModule(function (module) {
  /**
   * Copyright (c) 2014-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  var runtime = function (exports) {
    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var undefined$1; // More compressible than void 0.

    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

    function define(obj, key, value) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
      return obj[key];
    }

    try {
      // IE 8 has a broken Object.defineProperty that only works on DOM objects.
      define({}, "");
    } catch (err) {
      define = function define(obj, key, value) {
        return obj[key] = value;
      };
    }

    function wrap(innerFn, outerFn, self, tryLocsList) {
      // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
      var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
      var generator = Object.create(protoGenerator.prototype);
      var context = new Context(tryLocsList || []); // The ._invoke method unifies the implementations of the .next,
      // .throw, and .return methods.

      generator._invoke = makeInvokeMethod(innerFn, self, context);
      return generator;
    }

    exports.wrap = wrap; // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.

    function tryCatch(fn, obj, arg) {
      try {
        return {
          type: "normal",
          arg: fn.call(obj, arg)
        };
      } catch (err) {
        return {
          type: "throw",
          arg: err
        };
      }
    }

    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed"; // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.

    var ContinueSentinel = {}; // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.

    function Generator() {}

    function GeneratorFunction() {}

    function GeneratorFunctionPrototype() {} // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.


    var IteratorPrototype = {};

    IteratorPrototype[iteratorSymbol] = function () {
      return this;
    };

    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));

    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
      // This environment has a native %IteratorPrototype%; use it instead
      // of the polyfill.
      IteratorPrototype = NativeIteratorPrototype;
    }

    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
    GeneratorFunctionPrototype.constructor = GeneratorFunction;
    GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"); // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.

    function defineIteratorMethods(prototype) {
      ["next", "throw", "return"].forEach(function (method) {
        define(prototype, method, function (arg) {
          return this._invoke(method, arg);
        });
      });
    }

    exports.isGeneratorFunction = function (genFun) {
      var ctor = typeof genFun === "function" && genFun.constructor;
      return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
      // do is to check its .name property.
      (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };

    exports.mark = function (genFun) {
      if (Object.setPrototypeOf) {
        Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
      } else {
        genFun.__proto__ = GeneratorFunctionPrototype;
        define(genFun, toStringTagSymbol, "GeneratorFunction");
      }

      genFun.prototype = Object.create(Gp);
      return genFun;
    }; // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.


    exports.awrap = function (arg) {
      return {
        __await: arg
      };
    };

    function AsyncIterator(generator, PromiseImpl) {
      function invoke(method, arg, resolve, reject) {
        var record = tryCatch(generator[method], generator, arg);

        if (record.type === "throw") {
          reject(record.arg);
        } else {
          var result = record.arg;
          var value = result.value;

          if (value && typeof value === "object" && hasOwn.call(value, "__await")) {
            return PromiseImpl.resolve(value.__await).then(function (value) {
              invoke("next", value, resolve, reject);
            }, function (err) {
              invoke("throw", err, resolve, reject);
            });
          }

          return PromiseImpl.resolve(value).then(function (unwrapped) {
            // When a yielded Promise is resolved, its final value becomes
            // the .value of the Promise<{value,done}> result for the
            // current iteration.
            result.value = unwrapped;
            resolve(result);
          }, function (error) {
            // If a rejected Promise was yielded, throw the rejection back
            // into the async generator function so it can be handled there.
            return invoke("throw", error, resolve, reject);
          });
        }
      }

      var previousPromise;

      function enqueue(method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }

        return previousPromise = // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
        // invocations of the iterator.
        callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      } // Define the unified helper method that is used to implement .next,
      // .throw, and .return (see defineIteratorMethods).


      this._invoke = enqueue;
    }

    defineIteratorMethods(AsyncIterator.prototype);

    AsyncIterator.prototype[asyncIteratorSymbol] = function () {
      return this;
    };

    exports.AsyncIterator = AsyncIterator; // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.

    exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
      if (PromiseImpl === void 0) PromiseImpl = Promise;
      var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
      return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function (result) {
        return result.done ? result.value : iter.next();
      });
    };

    function makeInvokeMethod(innerFn, self, context) {
      var state = GenStateSuspendedStart;
      return function invoke(method, arg) {
        if (state === GenStateExecuting) {
          throw new Error("Generator is already running");
        }

        if (state === GenStateCompleted) {
          if (method === "throw") {
            throw arg;
          } // Be forgiving, per 25.3.3.3.3 of the spec:
          // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume


          return doneResult();
        }

        context.method = method;
        context.arg = arg;

        while (true) {
          var delegate = context.delegate;

          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);

            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }

          if (context.method === "next") {
            // Setting context._sent for legacy support of Babel's
            // function.sent implementation.
            context.sent = context._sent = context.arg;
          } else if (context.method === "throw") {
            if (state === GenStateSuspendedStart) {
              state = GenStateCompleted;
              throw context.arg;
            }

            context.dispatchException(context.arg);
          } else if (context.method === "return") {
            context.abrupt("return", context.arg);
          }

          state = GenStateExecuting;
          var record = tryCatch(innerFn, self, context);

          if (record.type === "normal") {
            // If an exception is thrown from innerFn, we leave state ===
            // GenStateExecuting and loop back for another invocation.
            state = context.done ? GenStateCompleted : GenStateSuspendedYield;

            if (record.arg === ContinueSentinel) {
              continue;
            }

            return {
              value: record.arg,
              done: context.done
            };
          } else if (record.type === "throw") {
            state = GenStateCompleted; // Dispatch the exception by looping back around to the
            // context.dispatchException(context.arg) call above.

            context.method = "throw";
            context.arg = record.arg;
          }
        }
      };
    } // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.


    function maybeInvokeDelegate(delegate, context) {
      var method = delegate.iterator[context.method];

      if (method === undefined$1) {
        // A .throw or .return when the delegate iterator has no .throw
        // method always terminates the yield* loop.
        context.delegate = null;

        if (context.method === "throw") {
          // Note: ["return"] must be used for ES3 parsing compatibility.
          if (delegate.iterator["return"]) {
            // If the delegate iterator has a return method, give it a
            // chance to clean up.
            context.method = "return";
            context.arg = undefined$1;
            maybeInvokeDelegate(delegate, context);

            if (context.method === "throw") {
              // If maybeInvokeDelegate(context) changed context.method from
              // "return" to "throw", let that override the TypeError below.
              return ContinueSentinel;
            }
          }

          context.method = "throw";
          context.arg = new TypeError("The iterator does not provide a 'throw' method");
        }

        return ContinueSentinel;
      }

      var record = tryCatch(method, delegate.iterator, context.arg);

      if (record.type === "throw") {
        context.method = "throw";
        context.arg = record.arg;
        context.delegate = null;
        return ContinueSentinel;
      }

      var info = record.arg;

      if (!info) {
        context.method = "throw";
        context.arg = new TypeError("iterator result is not an object");
        context.delegate = null;
        return ContinueSentinel;
      }

      if (info.done) {
        // Assign the result of the finished delegate to the temporary
        // variable specified by delegate.resultName (see delegateYield).
        context[delegate.resultName] = info.value; // Resume execution at the desired location (see delegateYield).

        context.next = delegate.nextLoc; // If context.method was "throw" but the delegate handled the
        // exception, let the outer generator proceed normally. If
        // context.method was "next", forget context.arg since it has been
        // "consumed" by the delegate iterator. If context.method was
        // "return", allow the original .return call to continue in the
        // outer generator.

        if (context.method !== "return") {
          context.method = "next";
          context.arg = undefined$1;
        }
      } else {
        // Re-yield the result returned by the delegate method.
        return info;
      } // The delegate iterator is finished, so forget it and continue with
      // the outer generator.


      context.delegate = null;
      return ContinueSentinel;
    } // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.


    defineIteratorMethods(Gp);
    define(Gp, toStringTagSymbol, "Generator"); // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.

    Gp[iteratorSymbol] = function () {
      return this;
    };

    Gp.toString = function () {
      return "[object Generator]";
    };

    function pushTryEntry(locs) {
      var entry = {
        tryLoc: locs[0]
      };

      if (1 in locs) {
        entry.catchLoc = locs[1];
      }

      if (2 in locs) {
        entry.finallyLoc = locs[2];
        entry.afterLoc = locs[3];
      }

      this.tryEntries.push(entry);
    }

    function resetTryEntry(entry) {
      var record = entry.completion || {};
      record.type = "normal";
      delete record.arg;
      entry.completion = record;
    }

    function Context(tryLocsList) {
      // The root entry object (effectively a try statement without a catch
      // or a finally block) gives us a place to store values thrown from
      // locations where there is no enclosing try statement.
      this.tryEntries = [{
        tryLoc: "root"
      }];
      tryLocsList.forEach(pushTryEntry, this);
      this.reset(true);
    }

    exports.keys = function (object) {
      var keys = [];

      for (var key in object) {
        keys.push(key);
      }

      keys.reverse(); // Rather than returning an object with a next method, we keep
      // things simple and return the next function itself.

      return function next() {
        while (keys.length) {
          var key = keys.pop();

          if (key in object) {
            next.value = key;
            next.done = false;
            return next;
          }
        } // To avoid creating an additional object, we just hang the .value
        // and .done properties off the next function object itself. This
        // also ensures that the minifier will not anonymize the function.


        next.done = true;
        return next;
      };
    };

    function values(iterable) {
      if (iterable) {
        var iteratorMethod = iterable[iteratorSymbol];

        if (iteratorMethod) {
          return iteratorMethod.call(iterable);
        }

        if (typeof iterable.next === "function") {
          return iterable;
        }

        if (!isNaN(iterable.length)) {
          var i = -1,
              next = function next() {
            while (++i < iterable.length) {
              if (hasOwn.call(iterable, i)) {
                next.value = iterable[i];
                next.done = false;
                return next;
              }
            }

            next.value = undefined$1;
            next.done = true;
            return next;
          };

          return next.next = next;
        }
      } // Return an iterator with no values.


      return {
        next: doneResult
      };
    }

    exports.values = values;

    function doneResult() {
      return {
        value: undefined$1,
        done: true
      };
    }

    Context.prototype = {
      constructor: Context,
      reset: function reset(skipTempReset) {
        this.prev = 0;
        this.next = 0; // Resetting context._sent for legacy support of Babel's
        // function.sent implementation.

        this.sent = this._sent = undefined$1;
        this.done = false;
        this.delegate = null;
        this.method = "next";
        this.arg = undefined$1;
        this.tryEntries.forEach(resetTryEntry);

        if (!skipTempReset) {
          for (var name in this) {
            // Not sure about the optimal order of these conditions:
            if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
              this[name] = undefined$1;
            }
          }
        }
      },
      stop: function stop() {
        this.done = true;
        var rootEntry = this.tryEntries[0];
        var rootRecord = rootEntry.completion;

        if (rootRecord.type === "throw") {
          throw rootRecord.arg;
        }

        return this.rval;
      },
      dispatchException: function dispatchException(exception) {
        if (this.done) {
          throw exception;
        }

        var context = this;

        function handle(loc, caught) {
          record.type = "throw";
          record.arg = exception;
          context.next = loc;

          if (caught) {
            // If the dispatched exception was caught by a catch block,
            // then let that catch block handle the exception normally.
            context.method = "next";
            context.arg = undefined$1;
          }

          return !!caught;
        }

        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          var record = entry.completion;

          if (entry.tryLoc === "root") {
            // Exception thrown outside of any try block that could handle
            // it, so set the completion value of the entire function to
            // throw the exception.
            return handle("end");
          }

          if (entry.tryLoc <= this.prev) {
            var hasCatch = hasOwn.call(entry, "catchLoc");
            var hasFinally = hasOwn.call(entry, "finallyLoc");

            if (hasCatch && hasFinally) {
              if (this.prev < entry.catchLoc) {
                return handle(entry.catchLoc, true);
              } else if (this.prev < entry.finallyLoc) {
                return handle(entry.finallyLoc);
              }
            } else if (hasCatch) {
              if (this.prev < entry.catchLoc) {
                return handle(entry.catchLoc, true);
              }
            } else if (hasFinally) {
              if (this.prev < entry.finallyLoc) {
                return handle(entry.finallyLoc);
              }
            } else {
              throw new Error("try statement without catch or finally");
            }
          }
        }
      },
      abrupt: function abrupt(type, arg) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];

          if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
            var finallyEntry = entry;
            break;
          }
        }

        if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
          // Ignore the finally entry if control is not jumping to a
          // location outside the try/catch block.
          finallyEntry = null;
        }

        var record = finallyEntry ? finallyEntry.completion : {};
        record.type = type;
        record.arg = arg;

        if (finallyEntry) {
          this.method = "next";
          this.next = finallyEntry.finallyLoc;
          return ContinueSentinel;
        }

        return this.complete(record);
      },
      complete: function complete(record, afterLoc) {
        if (record.type === "throw") {
          throw record.arg;
        }

        if (record.type === "break" || record.type === "continue") {
          this.next = record.arg;
        } else if (record.type === "return") {
          this.rval = this.arg = record.arg;
          this.method = "return";
          this.next = "end";
        } else if (record.type === "normal" && afterLoc) {
          this.next = afterLoc;
        }

        return ContinueSentinel;
      },
      finish: function finish(finallyLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];

          if (entry.finallyLoc === finallyLoc) {
            this.complete(entry.completion, entry.afterLoc);
            resetTryEntry(entry);
            return ContinueSentinel;
          }
        }
      },
      "catch": function _catch(tryLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];

          if (entry.tryLoc === tryLoc) {
            var record = entry.completion;

            if (record.type === "throw") {
              var thrown = record.arg;
              resetTryEntry(entry);
            }

            return thrown;
          }
        } // The context.catch method must only be called with a location
        // argument that corresponds to a known catch block.


        throw new Error("illegal catch attempt");
      },
      delegateYield: function delegateYield(iterable, resultName, nextLoc) {
        this.delegate = {
          iterator: values(iterable),
          resultName: resultName,
          nextLoc: nextLoc
        };

        if (this.method === "next") {
          // Deliberately forget the last sent value so that we don't
          // accidentally pass it on to the delegate.
          this.arg = undefined$1;
        }

        return ContinueSentinel;
      }
    }; // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.

    return exports;
  }( // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
  module.exports);

  try {
    regeneratorRuntime = runtime;
  } catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    Function("r", "regeneratorRuntime = r")(runtime);
  }
});

var _marked = /*#__PURE__*/runtime_1.mark(authSaga); // import { call, put, takeLatest } from 'redux-saga/effects'
// import { getType } from 'typesafe-actions'
// import { AxiosResponse } from 'axios'
// import actions from '../actions'


function authSaga() {
  return runtime_1.wrap(function authSaga$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
} // let renewTimeout: NodeJS.Timeout | undefined = undefined


var authSagas = {
  __proto__: null,
  'default': authSaga
};

var adminSignInByUsername = function adminSignInByUsername(parameters) {
  var axiosInstance = Client.axiosInstance;
  return axiosInstance.post('/api/admin/sign-in', parameters);
};

var adminSignInByToken = function adminSignInByToken(parameters) {
  var axiosInstance = Client.axiosInstance;
  return axiosInstance.post('/api/admin/sign-in', parameters);
};

var refreshAdminToken = function refreshAdminToken(parameters) {
  var axiosInstance = Client.axiosInstance;
  return axiosInstance.post('/api/admin/refresh', parameters, {
    headers: {
      Authorization: 'Bearer ' + parameters.token
    }
  });
};

var userSignInByEmail = function userSignInByEmail(parameters) {
  var axiosInstance = Client.axiosInstance;
  return axiosInstance.post('/api/user/sign-in', parameters);
};

var userSignInByToken = function userSignInByToken(parameters) {
  var axiosInstance = Client.axiosInstance;
  return axiosInstance.post('/api/user/sign-in', parameters);
};

var refreshUserToken = function refreshUserToken(parameters) {
  var axiosInstance = Client.axiosInstance;
  return axiosInstance.post('/api/user/refresh', parameters, {
    headers: {
      Authorization: 'Bearer ' + parameters.token
    }
  });
};

var userSignUp = function userSignUp(parameters) {
  var axiosInstance = Client.axiosInstance;
  return axiosInstance.post('/api/user/sign-up', parameters);
};

var userForgottenPassword = function userForgottenPassword(parameters) {
  var axiosInstance = Client.axiosInstance;
  return axiosInstance.post('/api/user/forgotten-password', parameters);
};

var userForgottenPasswordConfirm = function userForgottenPasswordConfirm(parameters) {
  var axiosInstance = Client.axiosInstance;
  return axiosInstance.post('/api/user/forgotten-password/confirm', parameters);
};

var userConfirm = function userConfirm(token, parameters) {
  var axiosInstance = Client.axiosInstance;
  return axiosInstance.post('/api/user/confirm', parameters, {
    headers: {
      Authorization: 'Bearer ' + token
    }
  });
};

var userResend = function userResend(token) {
  var axiosInstance = Client.axiosInstance;
  return axiosInstance.post('/api/user/resend', {}, {
    headers: {
      Authorization: 'Bearer ' + token
    }
  });
};

var userCheck = function userCheck(parameters) {
  var axiosInstance = Client.axiosInstance;
  return axiosInstance.post('/api/user/check', parameters);
};

var userResendEstablishmentCode = function userResendEstablishmentCode(parameters) {
  var axiosInstance = Client.axiosInstance;
  return axiosInstance.post('/api/user/resend-establishment-code', parameters);
};

var authMutations = {
  __proto__: null,
  adminSignInByUsername: adminSignInByUsername,
  adminSignInByToken: adminSignInByToken,
  refreshAdminToken: refreshAdminToken,
  userSignInByEmail: userSignInByEmail,
  userSignInByToken: userSignInByToken,
  refreshUserToken: refreshUserToken,
  userSignUp: userSignUp,
  userForgottenPassword: userForgottenPassword,
  userForgottenPasswordConfirm: userForgottenPasswordConfirm,
  userConfirm: userConfirm,
  userResend: userResend,
  userCheck: userCheck,
  userResendEstablishmentCode: userResendEstablishmentCode
};

var adminCreate = function adminCreate(token, parameters) {
  var axiosInstance = Client.axiosInstance;
  return axiosInstance.post('/api/admin/', parameters, {
    headers: {
      Authorization: 'Bearer ' + token
    }
  });
};

var adminUpdate = function adminUpdate(token, id, parameters) {
  var axiosInstance = Client.axiosInstance;
  var url = '/api/admin/:id'.replace(':id', id);
  return axiosInstance.patch(url, parameters, {
    headers: {
      Authorization: 'Bearer ' + token
    }
  });
};

var adminDelete = function adminDelete(token, id) {
  var axiosInstance = Client.axiosInstance;
  var url = '/api/admin/:id'.replace(':id', id);
  return axiosInstance["delete"](url, {
    headers: {
      Authorization: 'Bearer ' + token
    }
  });
};

var adminsMutations = {
  __proto__: null,
  adminCreate: adminCreate,
  adminUpdate: adminUpdate,
  adminDelete: adminDelete
};

var adminsList = function adminsList(token) {
  var axiosInstance = Client.axiosInstance;
  return axiosInstance.get('/api/admins/', {
    headers: {
      Authorization: 'Bearer ' + token
    }
  });
};

var adminGet = function adminGet(token, id) {
  var axiosInstance = Client.axiosInstance;
  var url = '/api/admin/:id'.replace(':id', id);
  return axiosInstance.get(url, {
    headers: {
      Authorization: 'Bearer ' + token
    }
  });
};

var adminsQueries = {
  __proto__: null,
  adminsList: adminsList,
  adminGet: adminGet
};

var establishmentPrepareUpload = function establishmentPrepareUpload(token, parameters) {
  var axiosInstance = Client.axiosInstance;
  return axiosInstance.post('/api/establishment/prepare-upload', parameters, {
    headers: {
      Authorization: 'Bearer ' + token
    }
  });
};

var establishmentCreate = function establishmentCreate(token, parameters) {
  var axiosInstance = Client.axiosInstance;
  return axiosInstance.post('/api/establishment/', parameters, {
    headers: {
      Authorization: 'Bearer ' + token
    }
  });
};

var establishmentUpdate = function establishmentUpdate(token, id, parameters) {
  var axiosInstance = Client.axiosInstance;
  var url = '/api/establishment/:id'.replace(':id', id);
  return axiosInstance.patch(url, parameters, {
    headers: {
      Authorization: 'Bearer ' + token
    }
  });
};

var establishmentDelete = function establishmentDelete(token, id) {
  var axiosInstance = Client.axiosInstance;
  var url = '/api/establishment/:id'.replace(':id', id);
  return axiosInstance["delete"](url, {
    headers: {
      Authorization: 'Bearer ' + token
    }
  });
};

var putFile = function putFile(url, file) {
  var axiosInstance = Client.axiosInstance;
  return axiosInstance.put(url, file, {
    headers: {
      'Content-Type': file.type
    }
  });
};

var establishmentsExport = function establishmentsExport(token) {
  var axiosInstance = Client.axiosInstance;
  return axiosInstance.post('/api/establishments/export', {}, {
    headers: {
      Authorization: 'Bearer ' + token
    }
  });
};

var establishmentSharePhoto = function establishmentSharePhoto(token, id) {
  var axiosInstance = Client.axiosInstance;
  var url = '/api/establishment/share/:id'.replace(':id', id);
  return axiosInstance.post(url, {}, {
    headers: {
      Authorization: 'Bearer ' + token
    }
  });
};

var establishmentsMutations = {
  __proto__: null,
  establishmentPrepareUpload: establishmentPrepareUpload,
  establishmentCreate: establishmentCreate,
  establishmentUpdate: establishmentUpdate,
  establishmentDelete: establishmentDelete,
  putFile: putFile,
  establishmentsExport: establishmentsExport,
  establishmentSharePhoto: establishmentSharePhoto
};

var establishmentsList = function establishmentsList(token, locale, withDisabled) {
  var axiosInstance = Client.axiosInstance;
  var url = '/api/establishments/';

  if (withDisabled !== undefined) {
    url += '?withDisabled=' + (withDisabled ? 'true' : 'false');

    if (locale !== undefined) {
      url += '&locale=' + locale;
    }
  } else {
    if (locale !== undefined) {
      url += '?locale=' + locale;
    }
  }

  return axiosInstance.get(url, token ? {
    headers: {
      Authorization: 'Bearer ' + token
    }
  } : {});
};

var establishmentGet = function establishmentGet(token, id, locale) {
  var axiosInstance = Client.axiosInstance;
  var url = '/api/establishment/:id'.replace(':id', id);

  if (locale !== undefined) {
    url += '?locale=' + locale;
  }

  return axiosInstance.get(url, {
    headers: {
      Authorization: 'Bearer ' + token
    }
  });
};

var establishmentsQueries = {
  __proto__: null,
  establishmentsList: establishmentsList,
  establishmentGet: establishmentGet
};

var userUpdate = function userUpdate(token, id, parameters) {
  var axiosInstance = Client.axiosInstance;
  var url = '/api/user/:id'.replace(':id', id);
  return axiosInstance.patch(url, parameters, {
    headers: {
      Authorization: 'Bearer ' + token
    }
  });
};

var userDelete = function userDelete(token, id) {
  var axiosInstance = Client.axiosInstance;
  var url = '/api/user/:id'.replace(':id', id);
  return axiosInstance["delete"](url, {
    headers: {
      Authorization: 'Bearer ' + token
    }
  });
};

var usersExport = function usersExport(token) {
  var axiosInstance = Client.axiosInstance;
  return axiosInstance.post('/api/users/export', {}, {
    headers: {
      Authorization: 'Bearer ' + token
    }
  });
};

var usersMutations = {
  __proto__: null,
  userUpdate: userUpdate,
  userDelete: userDelete,
  usersExport: usersExport
};

var usersList = function usersList(token) {
  var axiosInstance = Client.axiosInstance;
  return axiosInstance.get('/api/users/', token ? {
    headers: {
      Authorization: 'Bearer ' + token
    }
  } : {});
};

var userGet = function userGet(token, id) {
  var axiosInstance = Client.axiosInstance;
  var url = '/api/user/:id'.replace(':id', id);
  return axiosInstance.get(url, {
    headers: {
      Authorization: 'Bearer ' + token
    }
  });
};

var usersQueries = {
  __proto__: null,
  usersList: usersList,
  userGet: userGet
};

var categoriesSearch = function categoriesSearch(token, searchTerm, locale, limit) {
  if (limit === void 0) {
    limit = 10;
  }

  var axiosInstance = Client.axiosInstance;
  var url = '/api/categories/search';
  url += '?searchTerm=' + encodeURIComponent(searchTerm);
  url += '&locale=' + encodeURIComponent(locale);
  url += '&limit=' + limit;
  return axiosInstance.get(url, token ? {
    headers: {
      Authorization: 'Bearer ' + token
    }
  } : {}).then(function (result) {
    return result.data.categories;
  });
};

var category = function category(token, categoryId, locale) {
  var axiosInstance = Client.axiosInstance;
  var url = '/api/categories/category/:id'.replace(':id', encodeURIComponent(categoryId));
  url += '?locale=' + encodeURIComponent(locale);
  return axiosInstance.get(url, token ? {
    headers: {
      Authorization: 'Bearer ' + token
    }
  } : {}).then(function (result) {
    return result.data;
  });
};

var categoriesQueries = {
  __proto__: null,
  categoriesSearch: categoriesSearch,
  category: category
};

var mutations = /*#__PURE__*/_extends({}, authMutations, adminsMutations, establishmentsMutations, usersMutations);

var queries = /*#__PURE__*/_extends({}, adminsQueries, establishmentsQueries, usersQueries, categoriesQueries);

var getExpirationDate = function getExpirationDate(token) {
  var base64TokenData = token.split('.');
  var expiration = 0;

  if (base64TokenData.length > 1) {
    var tokenData = decode(base64TokenData[1]);
    var tokenObject = JSON.parse(tokenData);
    expiration = tokenObject.exp;
  }

  return expiration;
};

var getExpirationRemainingTime = function getExpirationRemainingTime(token) {
  return getExpirationDate(token) - Math.floor(Date.now() / 1000);
};

var getNextTimeRenew = function getNextTimeRenew(token) {
  return (getExpirationDate(token) - Math.floor(Date.now() / 1000)) * 3 / 4 * 1000;
};

var _marked$1 = /*#__PURE__*/runtime_1.mark(sessionSaga),
    _marked2 = /*#__PURE__*/runtime_1.mark(loadSession),
    _marked3 = /*#__PURE__*/runtime_1.mark(saveSessionSignIn),
    _marked4 = /*#__PURE__*/runtime_1.mark(saveSessionAdmin),
    _marked5 = /*#__PURE__*/runtime_1.mark(saveSessionUser),
    _marked6 = /*#__PURE__*/runtime_1.mark(destroySession),
    _marked7 = /*#__PURE__*/runtime_1.mark(scheduleRenewToken),
    _marked8 = /*#__PURE__*/runtime_1.mark(refreshToken),
    _marked9 = /*#__PURE__*/runtime_1.mark(scheduleUserRenewToken),
    _marked10 = /*#__PURE__*/runtime_1.mark(refreshUserToken$1);

function sessionSaga(init) {
  return runtime_1.wrap(function sessionSaga$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return takeLatest(getType(actions.start), loadSession);

        case 2:
          _context.next = 4;
          return takeLatest(getType(actions.adminSignIn), saveSessionSignIn);

        case 4:
          _context.next = 6;
          return takeLatest(getType(actions.adminSignIn), saveSessionAdmin);

        case 6:
          _context.next = 8;
          return takeLatest(getType(actions.adminSignIn), scheduleRenewToken);

        case 8:
          _context.next = 10;
          return takeLatest(getType(actions.adminSignOut), destroySession);

        case 10:
          _context.next = 12;
          return takeLatest(getType(actions.userSignIn), saveSessionSignIn);

        case 12:
          _context.next = 14;
          return takeLatest(getType(actions.userSignIn), saveSessionUser);

        case 14:
          _context.next = 16;
          return takeLatest(getType(actions.userSignIn), scheduleUserRenewToken);

        case 16:
          _context.next = 18;
          return takeLatest(getType(actions.userSignOut), destroySession);

        case 18:
          if (!init) {
            _context.next = 21;
            break;
          }

          _context.next = 21;
          return put(actions.start(false));

        case 21:
        case "end":
          return _context.stop();
      }
    }
  }, _marked$1);
}

function loadSession(action) {
  var started, persistentStorage, sessionStorage, admin, user, token, longLifeToken, remainingTime, response, _remainingTime, _response;

  return runtime_1.wrap(function loadSession$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          started = action.payload;

          if (started) {
            _context2.next = 56;
            break;
          }

          persistentStorage = Client.getPersistentStorage();
          sessionStorage = Client.getSessionStorage();
          _context2.next = 6;
          return persistentStorage.getItem(prefix + '/auth/admin');

        case 6:
          admin = _context2.sent;
          _context2.next = 9;
          return persistentStorage.getItem(prefix + '/auth/user');

        case 9:
          user = _context2.sent;
          _context2.next = 12;
          return sessionStorage.getItem(prefix + '/auth/token');

        case 12:
          token = _context2.sent;
          _context2.next = 15;
          return persistentStorage.getItem(prefix + '/auth/longLifeToken');

        case 15:
          longLifeToken = _context2.sent;

          if (!(admin !== null)) {
            _context2.next = 36;
            break;
          }

          if (!(token !== null && token !== '')) {
            _context2.next = 22;
            break;
          }

          remainingTime = getExpirationRemainingTime(token);

          if (!(remainingTime > 10)) {
            _context2.next = 22;
            break;
          }

          _context2.next = 22;
          return put(actions.adminSignIn({
            admin: JSON.parse(admin),
            authentication: {
              token: token,
              longLifeToken: longLifeToken == null ? undefined : longLifeToken
            }
          }));

        case 22:
          if (!(longLifeToken !== null && longLifeToken !== '')) {
            _context2.next = 34;
            break;
          }

          _context2.prev = 23;
          _context2.next = 26;
          return call(mutations.adminSignInByToken, {
            token: longLifeToken
          });

        case 26:
          response = _context2.sent;

          if (!response.data) {
            _context2.next = 30;
            break;
          }

          _context2.next = 30;
          return put(actions.adminSignIn(response.data));

        case 30:
          _context2.next = 34;
          break;

        case 32:
          _context2.prev = 32;
          _context2.t0 = _context2["catch"](23);

        case 34:
          _context2.next = 54;
          break;

        case 36:
          if (!(user !== null)) {
            _context2.next = 54;
            break;
          }

          if (!(token !== null && token !== '')) {
            _context2.next = 42;
            break;
          }

          _remainingTime = getExpirationRemainingTime(token);

          if (!(_remainingTime > 10)) {
            _context2.next = 42;
            break;
          }

          _context2.next = 42;
          return put(actions.userSignIn({
            user: JSON.parse(user),
            authentication: {
              token: token,
              longLifeToken: longLifeToken == null ? undefined : longLifeToken
            }
          }));

        case 42:
          if (!(longLifeToken !== null && longLifeToken !== '')) {
            _context2.next = 54;
            break;
          }

          _context2.prev = 43;
          _context2.next = 46;
          return call(mutations.userSignInByToken, {
            token: longLifeToken
          });

        case 46:
          _response = _context2.sent;

          if (!_response.data) {
            _context2.next = 50;
            break;
          }

          _context2.next = 50;
          return put(actions.userSignIn(_response.data));

        case 50:
          _context2.next = 54;
          break;

        case 52:
          _context2.prev = 52;
          _context2.t1 = _context2["catch"](43);

        case 54:
          _context2.next = 56;
          return put(actions.start(true));

        case 56:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, null, [[23, 32], [43, 52]]);
}

function saveSessionSignIn(action) {
  var _action$payload$authe, token, longLifeToken, persistentStorage, sessionStorage;

  return runtime_1.wrap(function saveSessionSignIn$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _action$payload$authe = action.payload.authentication, token = _action$payload$authe.token, longLifeToken = _action$payload$authe.longLifeToken;
          persistentStorage = Client.getPersistentStorage();
          sessionStorage = Client.getSessionStorage();
          _context3.next = 5;
          return sessionStorage.setItem(prefix + '/auth/token', token !== null ? token : '');

        case 5:
          if (!longLifeToken) {
            _context3.next = 8;
            break;
          }

          _context3.next = 8;
          return persistentStorage.setItem(prefix + '/auth/longLifeToken', longLifeToken);

        case 8:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3);
}

function saveSessionAdmin(action) {
  var admin, persistentStorage;
  return runtime_1.wrap(function saveSessionAdmin$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          admin = action.payload.admin;
          persistentStorage = Client.getPersistentStorage();
          _context4.next = 4;
          return persistentStorage.setItem(prefix + '/auth/admin', admin !== null ? JSON.stringify(admin) : '');

        case 4:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4);
}

function saveSessionUser(action) {
  var user, persistentStorage;
  return runtime_1.wrap(function saveSessionUser$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          user = action.payload.user;
          persistentStorage = Client.getPersistentStorage();
          _context5.next = 4;
          return persistentStorage.setItem(prefix + '/auth/user', user !== null ? JSON.stringify(user) : '');

        case 4:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5);
}

function destroySession() {
  var sessionStorage, persistentStorage;
  return runtime_1.wrap(function destroySession$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          sessionStorage = Client.getSessionStorage();
          persistentStorage = Client.getPersistentStorage();
          _context6.next = 4;
          return sessionStorage.removeItem(prefix + '/auth/token');

        case 4:
          _context6.next = 6;
          return persistentStorage.removeItem(prefix + '/auth/admin');

        case 6:
          _context6.next = 8;
          return persistentStorage.removeItem(prefix + '/auth/user');

        case 8:
          _context6.next = 10;
          return persistentStorage.removeItem(prefix + '/auth/longLifeToken');

        case 10:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked6);
}

var renewTimeout = undefined;

var delay = function delay(ms) {
  return new Promise(function (res) {
    renewTimeout = setTimeout(res, ms);
  });
};

function scheduleRenewToken(action) {
  var token, nextTimeRenew;
  return runtime_1.wrap(function scheduleRenewToken$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          token = action.payload.authentication.token;
          nextTimeRenew = getNextTimeRenew(token);

          if (!(nextTimeRenew > 0)) {
            _context7.next = 8;
            break;
          }

          if (renewTimeout !== undefined) {
            clearTimeout(renewTimeout);
          }

          _context7.next = 6;
          return delay(nextTimeRenew);

        case 6:
          _context7.next = 8;
          return refreshToken();

        case 8:
        case "end":
          return _context7.stop();
      }
    }
  }, _marked7);
}

function refreshToken() {
  var _yield$select, admin, token, longLifeToken, response, _response2;

  return runtime_1.wrap(function refreshToken$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return select(function (_ref) {
            var auth = _ref.remplisVert.auth;
            return {
              admin: auth.admin,
              token: auth.token,
              longLifeToken: auth.longLifeToken
            };
          });

        case 2:
          _yield$select = _context8.sent;
          admin = _yield$select.admin;
          token = _yield$select.token;
          longLifeToken = _yield$select.longLifeToken;
          _context8.prev = 6;
          _context8.next = 9;
          return call(mutations.refreshAdminToken, {
            token: token
          });

        case 9:
          response = _context8.sent;

          if (!response.data) {
            _context8.next = 13;
            break;
          }

          _context8.next = 13;
          return put(actions.adminSignIn({
            admin: admin,
            authentication: {
              token: response.data.token,
              longLifeToken: longLifeToken
            }
          }));

        case 13:
          _context8.next = 35;
          break;

        case 15:
          _context8.prev = 15;
          _context8.t0 = _context8["catch"](6);

          if (!longLifeToken) {
            _context8.next = 33;
            break;
          }

          _context8.prev = 18;
          _context8.next = 21;
          return call(mutations.adminSignInByToken, {
            token: longLifeToken
          });

        case 21:
          _response2 = _context8.sent;

          if (!_response2.data) {
            _context8.next = 25;
            break;
          }

          _context8.next = 25;
          return put(actions.adminSignIn(_response2.data));

        case 25:
          _context8.next = 31;
          break;

        case 27:
          _context8.prev = 27;
          _context8.t1 = _context8["catch"](18);
          _context8.next = 31;
          return put(actions.adminSignOut());

        case 31:
          _context8.next = 35;
          break;

        case 33:
          _context8.next = 35;
          return put(actions.adminSignOut());

        case 35:
        case "end":
          return _context8.stop();
      }
    }
  }, _marked8, null, [[6, 15], [18, 27]]);
}

function scheduleUserRenewToken(action) {
  var token, nextTimeRenew;
  return runtime_1.wrap(function scheduleUserRenewToken$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          token = action.payload.authentication.token;
          nextTimeRenew = getNextTimeRenew(token);

          if (!(nextTimeRenew > 0)) {
            _context9.next = 8;
            break;
          }

          if (renewTimeout !== undefined) {
            clearTimeout(renewTimeout);
          }

          _context9.next = 6;
          return delay(nextTimeRenew);

        case 6:
          _context9.next = 8;
          return refreshUserToken$1();

        case 8:
        case "end":
          return _context9.stop();
      }
    }
  }, _marked9);
}

function refreshUserToken$1() {
  var _yield$select2, user, token, longLifeToken, response, _response3;

  return runtime_1.wrap(function refreshUserToken$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 2;
          return select(function (_ref2) {
            var auth = _ref2.remplisVert.auth;
            return {
              user: auth.user,
              token: auth.token,
              longLifeToken: auth.longLifeToken
            };
          });

        case 2:
          _yield$select2 = _context10.sent;
          user = _yield$select2.user;
          token = _yield$select2.token;
          longLifeToken = _yield$select2.longLifeToken;
          _context10.prev = 6;
          _context10.next = 9;
          return call(mutations.refreshUserToken, {
            token: token
          });

        case 9:
          response = _context10.sent;

          if (!response.data) {
            _context10.next = 13;
            break;
          }

          _context10.next = 13;
          return put(actions.userSignIn({
            user: user,
            authentication: {
              token: response.data.token,
              longLifeToken: longLifeToken
            }
          }));

        case 13:
          _context10.next = 35;
          break;

        case 15:
          _context10.prev = 15;
          _context10.t0 = _context10["catch"](6);

          if (!longLifeToken) {
            _context10.next = 33;
            break;
          }

          _context10.prev = 18;
          _context10.next = 21;
          return call(mutations.userSignInByToken, {
            token: longLifeToken
          });

        case 21:
          _response3 = _context10.sent;

          if (!_response3.data) {
            _context10.next = 25;
            break;
          }

          _context10.next = 25;
          return put(actions.userSignIn(_response3.data));

        case 25:
          _context10.next = 31;
          break;

        case 27:
          _context10.prev = 27;
          _context10.t1 = _context10["catch"](18);
          _context10.next = 31;
          return put(actions.userSignOut());

        case 31:
          _context10.next = 35;
          break;

        case 33:
          _context10.next = 35;
          return put(actions.userSignOut());

        case 35:
        case "end":
          return _context10.stop();
      }
    }
  }, _marked10, null, [[6, 15], [18, 27]]);
}

var sessionSagas = {
  __proto__: null,
  'default': sessionSaga
};
var UnexpectedError = 'UnexpectedError';

var APIError = /*#__PURE__*/function (_Error) {
  _inheritsLoose(APIError, _Error);

  function APIError(type, message, data) {
    var _this;

    if (type === void 0) {
      type = UnexpectedError;
    }

    _this = _Error.call(this, message ? message : type) || this;
    _this.name = type;
    _this.type = type;
    _this.data = data;
    return _this;
  }

  return APIError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var generateError = function generateError(error) {
  var _error$response;

  if (error === void 0) {
    error = undefined;
  }

  if (error === undefined) {
    return new APIError();
  }

  var errorType = error.code;
  var message = error.message;
  var data = (_error$response = error.response) == null ? void 0 : _error$response.data;
  return new APIError(errorType, message, data);
};

var _marked$2 = /*#__PURE__*/runtime_1.mark(establishmentsSaga),
    _marked2$1 = /*#__PURE__*/runtime_1.mark(fetchEstablishments$1);

function establishmentsSaga() {
  return runtime_1.wrap(function establishmentsSaga$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return takeLatest(getType(actions.fetchEstablishments), fetchEstablishments$1);

        case 2:
        case "end":
          return _context.stop();
      }
    }
  }, _marked$2);
}

function fetchEstablishments$1(action) {
  var _action$payload, token, locale, _yield$call, data;

  return runtime_1.wrap(function fetchEstablishments$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _action$payload = action.payload, token = _action$payload.token, locale = _action$payload.locale;
          _context2.prev = 1;
          _context2.next = 4;
          return call(queries.establishmentsList, token, locale);

        case 4:
          _yield$call = _context2.sent;
          data = _yield$call.data;

          if (!data) {
            _context2.next = 11;
            break;
          }

          _context2.next = 9;
          return put(actions.setEstablishments(data));

        case 9:
          _context2.next = 13;
          break;

        case 11:
          _context2.next = 13;
          return put(actions.setError(generateError()));

        case 13:
          _context2.next = 19;
          break;

        case 15:
          _context2.prev = 15;
          _context2.t0 = _context2["catch"](1);
          _context2.next = 19;
          return put(actions.setError(generateError(_context2.t0)));

        case 19:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2$1, null, [[1, 15]]);
}

var establishmentsSagas = {
  __proto__: null,
  'default': establishmentsSaga
};

var _marked$3 = /*#__PURE__*/runtime_1.mark(remplisVertSaga);

function remplisVertSaga(init) {
  return runtime_1.wrap(function remplisVertSaga$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if (init === void 0) {
            init = true;
          }

          _context.next = 3;
          return all([call(authSaga), call(sessionSaga, init), call(establishmentsSaga)]);

        case 3:
        case "end":
          return _context.stop();
      }
    }
  }, _marked$3);
}

var remplisVertSagas = /*#__PURE__*/_extends({}, authSagas, sessionSagas, establishmentsSagas);

var RemplisVertContext = /*#__PURE__*/React.createContext(null);
var useDispatch = /*#__PURE__*/createDispatchHook(RemplisVertContext);
var useSelector = /*#__PURE__*/createSelectorHook(RemplisVertContext);

var useAdminSignInByUsername = function useAdminSignInByUsername() {
  var dispatch = useDispatch();

  var _useState = useState(false),
      inProgress = _useState[0],
      setInProgress = _useState[1];

  var signInAdminByEmail = useCallback(function (payload) {
    setInProgress(true);
    return mutations.adminSignInByUsername(payload).then(function (_ref) {
      var data = _ref.data;
      setInProgress(false);

      if (data) {
        dispatch(actions.adminSignIn(data));
        return data;
      }

      throw generateError();
    })["catch"](function (error) {
      setInProgress(false);
      dispatch(actions.adminSignOut());
      throw generateError(error);
    });
  }, [dispatch]);
  return {
    signInAdminByEmail: signInAdminByEmail,
    inProgress: inProgress
  };
};

var useAdminUpdateMe = function useAdminUpdateMe() {
  var dispatch = useDispatch();

  var _useState = useState(false),
      inProgress = _useState[0],
      setInProgress = _useState[1];

  var adminUpdateMe = useCallback(function (token, id, payload) {
    setInProgress(true);
    return mutations.adminUpdate(token, id, payload).then(function (_ref) {
      var data = _ref.data;
      setInProgress(false);

      if (data && data.authentication) {
        dispatch(actions.adminSignIn(data));
        return data;
      }

      throw generateError();
    })["catch"](function (error) {
      setInProgress(false);
      throw generateError(error);
    });
  }, [dispatch]);
  return {
    adminUpdateMe: adminUpdateMe,
    inProgress: inProgress
  };
};

var useAdminSignOut = function useAdminSignOut() {
  var dispatch = useDispatch();

  var signOut = function signOut() {
    dispatch(actions.adminSignOut());
  };

  return {
    signOut: signOut
  };
};

var useUserSignInByEmail = function useUserSignInByEmail() {
  var dispatch = useDispatch();

  var _useState = useState(false),
      inProgress = _useState[0],
      setInProgress = _useState[1];

  var signInUserByEmail = useCallback(function (payload) {
    setInProgress(true);
    return mutations.userSignInByEmail(payload).then(function (_ref) {
      var data = _ref.data;
      setInProgress(false);

      if (data) {
        dispatch(actions.userSignIn(data));
        return data;
      }

      throw generateError();
    })["catch"](function (error) {
      setInProgress(false);
      dispatch(actions.userSignOut());
      throw generateError(error);
    });
  }, [dispatch]);
  return {
    signInUserByEmail: signInUserByEmail,
    inProgress: inProgress
  };
};

var useUserSignOut = function useUserSignOut() {
  var dispatch = useDispatch();

  var signOut = function signOut() {
    dispatch(actions.userSignOut());
  };

  return {
    signOut: signOut
  };
};

var useUserUpdateMe = function useUserUpdateMe() {
  var dispatch = useDispatch();

  var _useState = useState(false),
      inProgress = _useState[0],
      setInProgress = _useState[1];

  var userUpdateMe = useCallback(function (token, id, payload) {
    setInProgress(true);
    return mutations.userUpdate(token, id, payload).then(function (_ref) {
      var data = _ref.data;
      setInProgress(false);

      if (data && data.authentication) {
        dispatch(actions.userSignIn(data));
        return data;
      }

      throw generateError();
    })["catch"](function (error) {
      setInProgress(false);
      throw generateError(error);
    });
  }, [dispatch]);
  return {
    userUpdateMe: userUpdateMe,
    inProgress: inProgress
  };
};

var useUserSignUp = function useUserSignUp() {
  var dispatch = useDispatch();

  var _useState = useState(false),
      inProgress = _useState[0],
      setInProgress = _useState[1];

  var signUpUser = useCallback(function (payload) {
    setInProgress(true);
    return mutations.userSignUp(payload).then(function (_ref) {
      var data = _ref.data;
      setInProgress(false);

      if (data) {
        dispatch(actions.userSignIn(data));
        return data;
      }

      throw generateError();
    })["catch"](function (error) {
      setInProgress(false);
      throw generateError(error);
    });
  }, [dispatch]);
  return {
    signUpUser: signUpUser,
    inProgress: inProgress
  };
};

var useUserForgottenPassword = function useUserForgottenPassword() {
  var _useState = useState(false),
      inProgress = _useState[0],
      setInProgress = _useState[1];

  var userForgottenPassword = useCallback(function (payload) {
    setInProgress(true);
    return mutations.userForgottenPassword(payload).then(function () {
      setInProgress(false);
    })["catch"](function (error) {
      setInProgress(false);
      throw generateError(error);
    });
  }, []);
  return {
    userForgottenPassword: userForgottenPassword,
    inProgress: inProgress
  };
};

var useUserForgottenPasswordConfirm = function useUserForgottenPasswordConfirm() {
  var _useState = useState(false),
      inProgress = _useState[0],
      setInProgress = _useState[1];

  var userForgottenPasswordConfirm = useCallback(function (payload) {
    setInProgress(true);
    return mutations.userForgottenPasswordConfirm(payload).then(function () {
      setInProgress(false);
    })["catch"](function (error) {
      setInProgress(false);
      throw generateError(error);
    });
  }, []);
  return {
    userForgottenPasswordConfirm: userForgottenPasswordConfirm,
    inProgress: inProgress
  };
};

var useUserConfirm = function useUserConfirm() {
  var dispatch = useDispatch();

  var _useState = useState(false),
      inProgress = _useState[0],
      setInProgress = _useState[1];

  var userConfirm = useCallback(function (token, payload) {
    setInProgress(true);
    return mutations.userConfirm(token, payload).then(function (_ref) {
      var data = _ref.data;
      setInProgress(false);

      if (data) {
        dispatch(actions.userSignIn(data));
        return data;
      }

      throw generateError();
    })["catch"](function (error) {
      setInProgress(false);
      throw generateError(error);
    });
  }, [dispatch]);
  return {
    userConfirm: userConfirm,
    inProgress: inProgress
  };
};

var useUserResend = function useUserResend() {
  var _useState = useState(false),
      inProgress = _useState[0],
      setInProgress = _useState[1];

  var userResend = useCallback(function (token) {
    setInProgress(true);
    return mutations.userResend(token).then(function () {
      setInProgress(false);
    })["catch"](function (error) {
      setInProgress(false);
      throw generateError(error);
    });
  }, []);
  return {
    userResend: userResend,
    inProgress: inProgress
  };
};

var useUserCheck = function useUserCheck() {
  var _useState = useState(false),
      inProgress = _useState[0],
      setInProgress = _useState[1];

  var userCheck = useCallback(function (payload) {
    setInProgress(true);
    return mutations.userCheck(payload).then(function (_ref) {
      var data = _ref.data;

      if (data) {
        return data;
      }

      throw generateError();
    })["catch"](function (error) {
      throw generateError(error);
    })["finally"](function () {
      setInProgress(false);
    });
  }, []);
  return {
    userCheck: userCheck,
    inProgress: inProgress
  };
};

var useUserResendEstablishmentCode = function useUserResendEstablishmentCode() {
  var _useState = useState(false),
      inProgress = _useState[0],
      setInProgress = _useState[1];

  var userResendEstablishmentCode = useCallback(function (payload) {
    setInProgress(true);
    return mutations.userResendEstablishmentCode(payload).then(function () {})["catch"](function (error) {
      throw generateError(error);
    })["finally"](function () {
      setInProgress(false);
    });
  }, []);
  return {
    userResendEstablishmentCode: userResendEstablishmentCode,
    inProgress: inProgress
  };
};

var useAdminCreate = function useAdminCreate() {
  var dispatch = useDispatch();

  var _useState = useState(false),
      inProgress = _useState[0],
      setInProgress = _useState[1];

  var adminCreate = function adminCreate(token, payload) {
    setInProgress(true);
    return mutations.adminCreate(token, payload).then(function (_ref) {
      var data = _ref.data;
      setInProgress(false);

      if (data) {
        dispatch(actions.addAdmin(data));
        return data;
      }

      throw generateError();
    })["catch"](function (error) {
      setInProgress(false);
      throw generateError(error);
    });
  };

  return {
    adminCreate: adminCreate,
    inProgress: inProgress
  };
};

var useAdminsList = function useAdminsList() {
  var dispatch = useDispatch();

  var _useState = useState(false),
      inProgress = _useState[0],
      setInProgress = _useState[1];

  var adminsList = function adminsList(token) {
    setInProgress(true);
    return queries.adminsList(token).then(function (_ref) {
      var data = _ref.data;
      setInProgress(false);

      if (data) {
        dispatch(actions.setAdmins(data));
        return data;
      }

      throw generateError();
    })["catch"](function (error) {
      setInProgress(false);
      throw generateError(error);
    });
  };

  return {
    adminsList: adminsList,
    inProgress: inProgress
  };
};

var useAdminUpdate = function useAdminUpdate() {
  var dispatch = useDispatch();

  var _useState = useState(false),
      inProgress = _useState[0],
      setInProgress = _useState[1];

  var adminUpdate = function adminUpdate(token, id, payload) {
    setInProgress(true);
    return mutations.adminUpdate(token, id, payload).then(function (_ref) {
      var data = _ref.data;
      setInProgress(false);

      if (data && data.id) {
        dispatch(actions.updateAdmin(data));
        return data;
      }

      throw generateError();
    })["catch"](function (error) {
      setInProgress(false);
      throw generateError(error);
    });
  };

  return {
    adminUpdate: adminUpdate,
    inProgress: inProgress
  };
};

var useAdminDelete = function useAdminDelete() {
  var dispatch = useDispatch();

  var _useState = useState(false),
      inProgress = _useState[0],
      setInProgress = _useState[1];

  var adminDelete = function adminDelete(token, id) {
    setInProgress(true);
    return mutations.adminDelete(token, id).then(function () {
      setInProgress(false);
      dispatch(actions.deleteAdmin(id));
      return;
    })["catch"](function (error) {
      setInProgress(false);
      throw generateError(error);
    });
  };

  return {
    adminDelete: adminDelete,
    inProgress: inProgress
  };
};

var useAdminGet = function useAdminGet() {
  var dispatch = useDispatch();

  var _useState = useState(false),
      inProgress = _useState[0],
      setInProgress = _useState[1];

  var adminGet = function adminGet(token, adminId) {
    setInProgress(true);
    return queries.adminGet(token, adminId).then(function (_ref) {
      var data = _ref.data;
      setInProgress(false);

      if (data) {
        dispatch(actions.setAdmin(data));
        return data;
      }

      throw generateError();
    })["catch"](function (error) {
      setInProgress(false);
      throw generateError(error);
    });
  };

  return {
    adminGet: adminGet,
    inProgress: inProgress
  };
};

var useCategoriesSearch = function useCategoriesSearch() {
  var _useState = useState(false),
      inProgress = _useState[0],
      setInProgress = _useState[1];

  var categoriesSearch = useCallback(function (token, searchTerm, locale, limit) {
    if (limit === void 0) {
      limit = 10;
    }

    if (searchTerm.length > 2) {
      setInProgress(true);
      return queries.categoriesSearch(token, searchTerm, locale, limit).then(function (data) {
        if (data) {
          return data;
        }

        return [];
      })["catch"](function (error) {
        throw generateError(error);
      })["finally"](function () {
        setInProgress(false);
      });
    } else {
      return Promise.resolve([]);
    }
  }, []);
  return {
    categoriesSearch: categoriesSearch,
    inProgress: inProgress
  };
};

var useCategoryGet = function useCategoryGet() {
  var _useState = useState(false),
      inProgress = _useState[0],
      setInProgress = _useState[1];

  var categoryGet = useCallback(function (token, categoryId, locale) {
    setInProgress(true);
    return queries.category(token, categoryId, locale).then(function (data) {
      if (data) {
        return data;
      }

      return null;
    })["catch"](function (error) {
      throw generateError(error);
    })["finally"](function () {
      setInProgress(false);
    });
  }, []);
  return {
    categoryGet: categoryGet,
    inProgress: inProgress
  };
};

var useEstablishmentCreate = function useEstablishmentCreate() {
  var dispatch = useDispatch();

  var _useSelector = useSelector(function (_ref) {
    var auth = _ref.remplisVert.auth;
    return {
      user: auth.user
    };
  }),
      user = _useSelector.user;

  var _useState = useState(false),
      inProgress = _useState[0],
      setInProgress = _useState[1];

  var internalEstablishmentCreate = useCallback(function (token, payload) {
    return mutations.establishmentCreate(token, payload).then(function (_ref2) {
      var data = _ref2.data;
      setInProgress(false);

      if (data) {
        if (user) {
          var response = data;
          dispatch(actions.addEstablishment(response.establishment));
          dispatch(actions.userSignIn({
            user: response.user,
            authentication: response.authentication
          }));
        } else {
          var _response = data;
          dispatch(actions.addEstablishment(_response));
        }

        return data;
      }

      throw generateError();
    });
  }, [dispatch, user]);
  var establishmentCreate = useCallback(function (token, payload) {
    setInProgress(true);
    var image = payload.image;

    if (image) {
      return mutations.establishmentPrepareUpload(token, {
        contentType: image.type,
        size: image.size
      }).then(function (response) {
        var _response$data = response.data,
            url = _response$data.url,
            key = _response$data.key;
        return mutations.putFile(url, image).then(function () {
          return internalEstablishmentCreate(token, _extends({}, payload, {
            key: key
          }));
        });
      })["catch"](function (error) {
        setInProgress(false);
        throw generateError(error);
      });
    }

    return internalEstablishmentCreate(token, payload)["catch"](function (error) {
      setInProgress(false);
      throw generateError(error);
    });
  }, [internalEstablishmentCreate]);
  return {
    establishmentCreate: establishmentCreate,
    inProgress: inProgress
  };
};

var useEstablishmentsList = function useEstablishmentsList() {
  var dispatch = useDispatch();

  var _useState = useState(false),
      inProgress = _useState[0],
      setInProgress = _useState[1];

  var establishmentsList = useCallback(function (token, locale, withDisabled) {
    setInProgress(true);
    return queries.establishmentsList(token, locale, withDisabled).then(function (_ref) {
      var data = _ref.data;

      if (data) {
        dispatch(actions.setEstablishments(data));
        setInProgress(false);
        return data;
      }

      setInProgress(false);
      throw generateError();
    })["catch"](function (error) {
      setInProgress(false);
      throw generateError(error);
    });
  }, [dispatch]);
  return {
    establishmentsList: establishmentsList,
    inProgress: inProgress
  };
};

var useEstablishmentUpdate = function useEstablishmentUpdate() {
  var dispatch = useDispatch();

  var _useState = useState(false),
      inProgress = _useState[0],
      setInProgress = _useState[1];

  var update = useCallback(function (token, id, payload) {
    return mutations.establishmentUpdate(token, id, payload).then(function (_ref) {
      var data = _ref.data;
      setInProgress(false);

      if (data) {
        dispatch(actions.updateEstablishment(data));
        return data;
      }

      throw generateError();
    });
  }, [dispatch]);
  var establishmentUpdate = useCallback(function (token, id, payload) {
    setInProgress(true);
    var image = payload.image;

    if (image) {
      return mutations.establishmentPrepareUpload(token, {
        contentType: image.type,
        size: image.size
      }).then(function (response) {
        var _response$data = response.data,
            url = _response$data.url,
            key = _response$data.key;
        return mutations.putFile(url, image).then(function () {
          return update(token, id, _extends({}, payload, {
            key: key
          }));
        });
      })["catch"](function (error) {
        setInProgress(false);
        throw generateError(error);
      });
    }

    return update(token, id, payload)["catch"](function (error) {
      setInProgress(false);
      throw generateError(error);
    });
  }, [update]);
  return {
    establishmentUpdate: establishmentUpdate,
    inProgress: inProgress
  };
};

var useEstablishmentDelete = function useEstablishmentDelete() {
  var dispatch = useDispatch();

  var _useState = useState(false),
      inProgress = _useState[0],
      setInProgress = _useState[1];

  var establishmentDelete = useCallback(function (token, id) {
    setInProgress(true);
    return mutations.establishmentDelete(token, id).then(function () {
      setInProgress(false);
      dispatch(actions.deleteEstablishment(id));
      return;
    })["catch"](function (error) {
      setInProgress(false);
      throw generateError(error);
    });
  }, [dispatch]);
  return {
    establishmentDelete: establishmentDelete,
    inProgress: inProgress
  };
};

var useEstablishmentGet = function useEstablishmentGet() {
  var dispatch = useDispatch();

  var _useState = useState(false),
      inProgress = _useState[0],
      setInProgress = _useState[1];

  var establishmentGet = useCallback(function (token, establishmentId, locale) {
    setInProgress(true);
    return queries.establishmentGet(token, establishmentId, locale).then(function (_ref) {
      var data = _ref.data;
      setInProgress(false);

      if (data) {
        dispatch(actions.setEstablishment(data));
        return data;
      }

      throw generateError();
    })["catch"](function (error) {
      setInProgress(false);
      throw generateError(error);
    });
  }, [dispatch]);
  return {
    establishmentGet: establishmentGet,
    inProgress: inProgress
  };
};

var useEstablishmentsExport = function useEstablishmentsExport() {
  var _useState = useState(false),
      inProgress = _useState[0],
      setInProgress = _useState[1];

  var establishmentsExport = useCallback(function (token) {
    setInProgress(true);
    return mutations.establishmentsExport(token).then(function (_ref) {
      var data = _ref.data;

      if (data) {
        setInProgress(false);
        return data;
      }

      setInProgress(false);
      throw generateError();
    })["catch"](function (error) {
      setInProgress(false);
      throw generateError(error);
    });
  }, []);
  return {
    establishmentsExport: establishmentsExport,
    inProgress: inProgress
  };
};

var useUsersList = function useUsersList() {
  var dispatch = useDispatch();

  var _useState = useState(false),
      inProgress = _useState[0],
      setInProgress = _useState[1];

  var usersList = useCallback(function (token) {
    setInProgress(true);
    return queries.usersList(token).then(function (_ref) {
      var data = _ref.data;
      setInProgress(false);

      if (data) {
        dispatch(actions.setUsers(data));
        return data;
      }

      throw generateError();
    })["catch"](function (error) {
      setInProgress(false);
      throw generateError(error);
    });
  }, [dispatch]);
  return {
    usersList: usersList,
    inProgress: inProgress
  };
};

var useUserUpdate = function useUserUpdate() {
  var dispatch = useDispatch();

  var _useState = useState(false),
      inProgress = _useState[0],
      setInProgress = _useState[1];

  var userUpdate = useCallback(function (token, id, payload) {
    setInProgress(true);
    return mutations.userUpdate(token, id, payload).then(function (_ref) {
      var data = _ref.data;
      setInProgress(false);

      if (data && data.id) {
        dispatch(actions.updateUser(data));
        return data;
      }

      throw generateError();
    })["catch"](function (error) {
      setInProgress(false);
      throw generateError(error);
    });
  }, [dispatch]);
  return {
    userUpdate: userUpdate,
    inProgress: inProgress
  };
};

var useUserDelete = function useUserDelete() {
  var dispatch = useDispatch();

  var _useState = useState(false),
      inProgress = _useState[0],
      setInProgress = _useState[1];

  var userDelete = useCallback(function (token, id) {
    setInProgress(true);
    return mutations.userDelete(token, id).then(function () {
      setInProgress(false);
      dispatch(actions.deleteUser(id));
      return;
    })["catch"](function (error) {
      setInProgress(false);
      throw generateError(error);
    });
  }, [dispatch]);
  return {
    userDelete: userDelete,
    inProgress: inProgress
  };
};

var useUserGet = function useUserGet() {
  var dispatch = useDispatch();

  var _useState = useState(false),
      inProgress = _useState[0],
      setInProgress = _useState[1];

  var userGet = useCallback(function (token, adminId) {
    setInProgress(true);
    return queries.userGet(token, adminId).then(function (_ref) {
      var data = _ref.data;
      setInProgress(false);

      if (data) {
        dispatch(actions.setUser(data));
        return data;
      }

      throw generateError();
    })["catch"](function (error) {
      setInProgress(false);
      throw generateError(error);
    });
  }, [dispatch]);
  return {
    userGet: userGet,
    inProgress: inProgress
  };
};

var useUsersExport = function useUsersExport() {
  var _useState = useState(false),
      inProgress = _useState[0],
      setInProgress = _useState[1];

  var usersExport = useCallback(function (token) {
    setInProgress(true);
    return mutations.usersExport(token).then(function (_ref) {
      var data = _ref.data;

      if (data) {
        setInProgress(false);
        return data;
      }

      setInProgress(false);
      throw generateError();
    })["catch"](function (error) {
      setInProgress(false);
      throw generateError(error);
    });
  }, []);
  return {
    usersExport: usersExport,
    inProgress: inProgress
  };
};

var RemplisVertProvider = function RemplisVertProvider(_ref) {
  var store = _ref.store,
      options = _ref.options,
      children = _ref.children;

  if (options) {
    Client.init(options);
  }

  return React.createElement(Provider, {
    store: store,
    context: RemplisVertContext
  }, children);
};

var init = function init(options) {
  Client.init(options);
  return Client;
};

export { APIError, PermissionActions, PermissionSubjects, RemplisVertProvider, UnexpectedError, actions, init, remplisVertReducer, remplisVertReducers, remplisVertSaga, remplisVertSagas, useAdminCreate, useAdminDelete, useAdminGet, useAdminSignInByUsername, useAdminSignOut, useAdminUpdate, useAdminUpdateMe, useAdminsList, useCategoriesSearch, useCategoryGet, useEstablishmentCreate, useEstablishmentDelete, useEstablishmentGet, useEstablishmentUpdate, useEstablishmentsExport, useEstablishmentsList, useUserCheck, useUserConfirm, useUserDelete, useUserForgottenPassword, useUserForgottenPasswordConfirm, useUserGet, useUserResend, useUserResendEstablishmentCode, useUserSignInByEmail, useUserSignOut, useUserSignUp, useUserUpdate, useUserUpdateMe, useUsersExport, useUsersList };